function getOs() {
    const os = ['Windows','Mac', 'Android', 'Ios', 'Linux']; // add your OS values
    const userOs = os.find(v=>navigator.appVersion.indexOf(v) >= 0);
    return userOs || 'Windows';
}
const OsObject = {
    Windows: {
        label: 'Windows',
        headerText: 'Anomica voor Windows downloaden',
        captionText: ' MacOS',
        buttonText: ' Windows',
        img: 'Windows',
        icon: 'game-icons:pc',
        downloadLink: "https://update.anomica.com/windows64/Anomica-Setup.exe"

    },
    Mac: {
        label: 'MacOS',
        headerText: 'Anomica voor MacOS downloaden',
        captionText: ' Windows',
        buttonText: ' MacOS',
        img: 'Mac',
        icon: 'ic:outline-laptop-mac',
        downloadLink: "https://update.anomica.com/mac/Anomica-Setup.pkg"
    },
    Android: {
        label: 'Android',
        headerText: 'Anomica voor Android downloaden',
        captionText: ' iOS, Mac, Windows',
        buttonText: 'Android',
        img: 'Android',
        icon: 'ic:outline-tablet-android',
        downloadLink: 'https://play.google.com/store/apps/details?id=com.curuno.vpnnederland'
    },
    iOS: {
        label: 'iOS',
        headerText: 'Anomica voor iOS downloaden',
        captionText: ' Android, MacOS, Windows',
        buttonText: 'iOS',
        img: 'Ios',
        icon: 'wpf:iphone',
        downloadLink: 'https://apps.apple.com/nl/app/vpn-nederland/id1450814725'
    },
    Linux: {
        label: 'Linux',
        headerText: 'Anomica voor Linux downloaden',
        captionText: ' Android, MacOS, Windows',
        buttonText: 'Linux',
        // buttonTextSecondary: 'Linux < 2',
        img: 'Windows',
        icon: 'arcticons:pc-creator',
        downloadLink: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb',
        downloadLinkSecondary: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb'
    },
    ManualOpenVpn: {
        label: 'Manual Setup',
        headerText: 'VPN Nederland voor Manual downloaden',
        captionText: ' Android, MacOS, Windows, Linux',
        buttonText: null,
        // buttonTextSecondary: 'Linux',
        img: 'Windows',
        icon: 'arcticons:pc-creator',
        downloadLink: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb',
        downloadLinkSecondary: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb'
    }
}

export {getOs, OsObject}
